import { Button as ReshapedButton } from "reshaped";

import {
    type Action,
    getActionAnchorProps,
    getActionButtonProps,
    getActionClickableProps,
} from "../../action/Action";
import Icon from "../Icon";
import type { IconName } from "../Icon/types";
import { buttonSize, feelingColor, roleVariant } from "./constants";
import type { ButtonSize } from "./types";

type ButtonFeeling = "danger" | "normal" | "minor";
type ButtonRole = "main" | "side" | "minor";

type IconButtonProps = {
    icon: IconName;
    action: Action;
    size?: ButtonSize;
    feeling?: ButtonFeeling;
    role?: ButtonRole;
    tabIndex?: number;
};

export default function IconButton(props: IconButtonProps) {
    const { feeling = "normal", role = "main", action, icon, size = "normal", tabIndex } = props;
    const anchorProps = getActionAnchorProps(action);
    const clickableProps = getActionClickableProps(action);
    const buttonProps = getActionButtonProps(action);
    const color = feelingColor[feeling];
    const variant = roleVariant[role];
    const r_size = buttonSize[size];
    return (
        <ReshapedButton
            {...anchorProps}
            {...clickableProps}
            {...buttonProps}
            icon={<Icon name={icon} />}
            color={color}
            variant={variant}
            size={r_size}
            {...(tabIndex === undefined ? {} : { attributes: { tabIndex } })}
        ></ReshapedButton>
    );
}
